import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

// INTERFACES
import { trackById } from '../../../shared/util';
import { OrderSalesInterface } from '../../interfaces/order-sales.interface';

import {
  OrderReturnInterface,
  OrderReturnItemInterface,
} from './../../interfaces/order-return.interface';

@Component({
  selector: 'lum-order-return-item-table',
  templateUrl: './order-return-item-table.component.html',
  styleUrls: ['./order-return-item-table.component.scss'],
})
export class OrderReturnItemTableComponent implements OnChanges {
  @Input()
  orderReturnItems :OrderReturnItemInterface[] = [];

  @Input()
  orderReturn :OrderReturnInterface;

  @Input()
  parentSalesOrder :OrderSalesInterface;

  @Input()
  restockingFee :number = 0;

  @Input()
  customRefundAmount :number = 0;

  trackById = trackById;

  constructor(private router :Router) {}

  ngOnChanges() :void {}

  get isRestock() :boolean {
    return this.orderReturn?.skipInventory === false ? true : false;
  }

  get refundItemQuantity() :number {
    let refundItemQuantity = 0;

    if (
      this.orderReturn.totalOrderQuantity &&
      this.orderReturn.totalOrderQuantity > 0
    ) {
      refundItemQuantity = this.orderReturn?.totalOrderQuantity;
    } else {
      refundItemQuantity = this.orderReturnItems.reduce(
        (total, orderReturnItem) => orderReturnItem.quantity + total,
        0,
      );
    }

    return refundItemQuantity;
  }

  get orderTotal() :number {
    return this.orderReturn?.orderTotal ?? 0;
  }

  get itemSubtotalRefund() :number {
    return this.orderReturn?.orderTotal ?? 0;
  }

  get grandTotalRefund() :number {
    let grandTotalRefund = 0;

    if (this.orderReturn.amountPaid && this.orderReturn.amountPaid > 0) {
      grandTotalRefund = this.orderReturn?.amountPaid;
    } else {
      grandTotalRefund =
        this.itemSubtotalRefund + this.restockingFee + this.customRefundAmount;
    }

    return grandTotalRefund;
  }
}
